const standardLayout = () =>
`
  <Tabs id="tabsContainer" defaultActiveKey={1}>
    <Nav
      bsStyle='tabs'
      background={bgColor}
      large
    >
      <NavItem eventKey={1}>
        <label>Maximum two lines</label>
      </NavItem>
      <NavItem eventKey={2}>
        <label>Tab 2</label>
      </NavItem>
      <NavItem eventKey={3}>
        <label>Tab 3</label>
      </NavItem>
    </Nav>
    <TabContent animation>
      <TabPane eventKey={1}>
        content of Tab 1
      </TabPane>
      <TabPane eventKey={2}>
        content of Tab 2
      </TabPane>
      <TabPane eventKey={3}>
        content of Tab 3
      </TabPane>
    </TabContent>
  </Tabs>
`;

const counterLayout = () =>
`
  <FilterableTabs
    items={items}
    primary_key={'section'}
    secondary_key={'year'}
    primary_label={'content type'}
    secondary_label={'sections'}
    size={'s'}
    render={content}>
  </FilterableTabs>
`;

const sectionLayout = () =>
`
  <TabsSection.Tabs>
    <TabsSection.Tab indexKey={1}>
      <label>Tab 1</label>
    </TabsSection.Tab>
    <TabsSection.Tab indexKey={2}>
      <label>Tab 2</label>
    </TabsSection.Tab>
    <TabsSection.Tab indexKey={3}>
      <label>Tab 3</label>
    </TabsSection.Tab>
  </TabsSection.Tabs>
  <TabsSection.Container indexKey={1}>Content of tab 1</TabsSection.Container>
  <TabsSection.Container indexKey={2}>Content of tab 2</TabsSection.Container>
  <TabsSection.Container indexKey={3}>Content of tab 3</TabsSection.Container>
`;

const horizontalSectionLayout = () =>
`
  <TabsSection.Tabs horizontal>
    <TabsSection.Tab indexKey={1}>
      <label>Tab 1</label>
    </TabsSection.Tab>
    <TabsSection.Tab indexKey={2}>
      <label>Tab 2</label>
    </TabsSection.Tab>
    <TabsSection.Tab indexKey={3}>
      <label>Tab 3</label>
    </TabsSection.Tab>
  </TabsSection.Tabs>
  <TabsSection.Container indexKey={1}>Content of tab 1</TabsSection.Container>
  <TabsSection.Container indexKey={2}>Content of tab 2</TabsSection.Container>
  <TabsSection.Container indexKey={3}>Content of tab 3</TabsSection.Container>
`;

const tabsTemplates = {
  standard: standardLayout(),
  section: sectionLayout(),
  counter: counterLayout(),
  horizontalSection: horizontalSectionLayout(),
};

export default tabsTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/constants/tabsTemplates.js